// @flow
import { connect } from 'react-redux'
import AudienceNameTemplateSelect from './AudienceNameTemplateSelect'
import type { Store } from '../../redux/ducks'
import { patch } from '../AudienceEditContainer'
import _ from 'lodash'

function mapStateToProps(state: Store) {
  const audienceState = state.audienceEdit

  return {
    options: _.map(audienceState.audienceNameTemplates, (template) => {
      return { id: template.id, name: template.name }
    }),
    value: audienceState.selectedAudienceNameTemplateId
  }
}

function mapDispatchToProps(dispatch: Function) {
  return {
    onChange: (value: number) => {
      patch(dispatch, { selectedAudienceNameTemplateId: value })
    }
  }
}

const AudienceNameTemplateSelectContainer = connect<Object, Object, _, _, _, _>(
  mapStateToProps,
  mapDispatchToProps
)(AudienceNameTemplateSelect)

export default AudienceNameTemplateSelectContainer
